import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const WinProbabilityChart = ({ allPlays, homeTeamName, awayTeamName }) => {
  const chartData = useMemo(() => {
    if (!allPlays?.length) return [];
    const points = [];
    allPlays.forEach((play, i) => {
      const wp = play.about?.homeScore !== undefined
        ? Math.min(95, Math.max(5, 50 + (play.about.homeScore - play.about.awayScore) * 8 + (play.about.inning > 7 ? (play.about.homeScore - play.about.awayScore) * 5 : 0)))
        : null;
      if (wp !== null) {
        points.push([i, Math.round(wp)]);
      }
    });
    return points;
  }, [allPlays]);

  const option = {
    backgroundColor: 'transparent',
    grid: { top: 30, right: 20, bottom: 40, left: 50 },
    xAxis: {
      type: 'value',
      min: 0,
      max: chartData.length - 1,
      axisLabel: { show: false },
      axisLine: { lineStyle: { color: '#658d71' } },
      splitLine: { show: false },
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
      axisLabel: { color: '#a9c9b1', fontSize: 10, formatter: '{value}%' },
      axisLine: { lineStyle: { color: '#658d71' } },
      splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } },
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e3a29',
      borderColor: '#658d71',
      textStyle: { color: '#d8ceb3', fontSize: 11 },
      formatter: (params) => {
        const val = params[0]?.value?.[1];
        return val != null ? `${homeTeamName}: ${val}% | ${awayTeamName}: ${100 - val}%` : '';
      },
    },
    series: [
      {
        type: 'line',
        data: chartData,
        smooth: true,
        lineStyle: { color: '#d8ceb3', width: 2 },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(216,206,179,0.3)' },
              { offset: 1, color: 'rgba(216,206,179,0.02)' },
            ],
          },
        },
        symbol: 'none',
      },
      {
        type: 'line',
        data: chartData.map(([x]) => [x, 50]),
        lineStyle: { color: '#c4333e', width: 1, type: 'dashed' },
        symbol: 'none',
        silent: true,
      },
    ],
  };

  if (!chartData.length) return (
    <div className="flex items-center justify-center h-40 text-[#658d71] text-xs tracking-widest uppercase">
      No win probability data available
    </div>
  );

  return (
    <div>
      <div className="flex justify-between text-[9px] uppercase tracking-widest font-bold mb-1 px-1">
        <span className="text-[#d8ceb3]">{homeTeamName} Win%</span>
        <span className="text-[#a9c9b1]">{awayTeamName} Win%</span>
      </div>
      <ReactECharts option={option} style={{ height: '180px' }} />
    </div>
  );
};

export default WinProbabilityChart;